import {DialogManager} from '@modifi/plugin-dialogs'

import SubmitProgressDialog, {DIALOG_NAME as DIALOG_SUBMIT_PROGRESS} from './submit-progress-dialog'
import ErrorDialog, {DIALOG_NAME as ERROR_DIALOG} from './error-dialog'

export {DIALOG_NAME as DIALOG_SUBMIT_PROGRESS} from './submit-progress-dialog'
export {DIALOG_NAME as ERROR_DIALOG} from './error-dialog'

DialogManager.addDialog(DIALOG_SUBMIT_PROGRESS, SubmitProgressDialog, {
  layoutProps: {closeOnBackdropClick: false, size: {col: 8, md: 6, lg: 4}, hasCloseButton: false},
})
DialogManager.addDialog(ERROR_DIALOG, ErrorDialog, {
  layoutProps: {closeOnBackdropClick: true, size: {col: 8, md: 6, lg: 4}, hasCloseButton: false},
})
